import LeftPane from "./LeftPane";

export default LeftPane;